import React from 'react';
import { MAX_CLAN_LEVEL, clanLevelPerks } from './clan-level';

interface Props {
  level?: number | null;
  levelPoints?: number | null;
  nextLevelPoints?: number | null;
}

const ClanLevelCard: React.FC<Props> = ({ level, levelPoints, nextLevelPoints }) => {
  const lv = level && level > 0 ? level : 1;
  const pts = Number(levelPoints ?? 0);
  const next = nextLevelPoints == null ? null : Number(nextLevelPoints);
  const pct = next && next > 0 ? Math.min(100, Math.round((pts / next) * 100)) : 100;
  const perks = clanLevelPerks(lv);
  return (
    <div className="flex flex-col gap-2 rounded-[16px] border-[1.5px] border-white/40 bg-gradient-to-b from-[#EAF2FF] to-white p-5 dark:from-slate-800 dark:to-slate-900">
      <div className="text-[15px] font-medium text-black dark:text-white">Cấp clan</div>
      <div className="text-[26px] font-bold text-black dark:text-white">Cấp {lv}</div>
      {lv < MAX_CLAN_LEVEL && next != null ? (
        <>
          <div className="h-2 w-full overflow-hidden rounded-full bg-black/10" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
            <div className="h-full rounded-full bg-[#066bff]" style={{ width: `${pct}%` }} />
          </div>
          <div className="text-[12px] text-black/60 dark:text-slate-400">
            {pts.toLocaleString('vi-VN')} / {next.toLocaleString('vi-VN')} điểm để lên cấp {lv + 1}
          </div>
        </>
      ) : (
        <div className="text-[12px] text-black/60 dark:text-slate-400">Đã đạt cấp cao nhất.</div>
      )}
      {perks.length > 0 && (
        <ul className="mt-1 list-disc pl-5 text-[13px] text-black dark:text-slate-200">
          {perks.map((p) => (
            <li key={p}>{p}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ClanLevelCard;
